// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__qjQLA","loader":"styles_loader___Fl7G"};